import React from 'react';
import { HeroBanner } from 'types/generated/graphql';
import SlideSkeleton from '../components/SlideSkeleton';
import getSlide from './getSlide';

const getSlides = ({ heroBanners }: { heroBanners?: HeroBanner[] }) => {
    const slides = [];

    if (!heroBanners || heroBanners.length === 0) {
        slides.unshift(<SlideSkeleton key="slide-skeleton-1" />);
    }

    if (heroBanners) {
        heroBanners.forEach((heroBanner: HeroBanner) => {
            slides.unshift(getSlide(heroBanner));
        });
    }

    return slides;
};

export default getSlides;
